import "../../editorStyleSheet.css"
import PropTypes from "prop-types";
import React, {useCallback, useEffect, useState} from 'react';
import {getScriptDirection} from "../../../../utlis/generalUtils";
import SaveButton from "../editorToolbarComponents/SaveButton";
import CircularProgress from '@mui/material/CircularProgress';
import AudioPlayer from "../wavesurfer/AudioPlayer";
import ReactMarkdown from 'react-markdown';
import 'react-edit-text/dist/index.css';
import SoftBox from "../../../../components/SoftBox";
import SoftTypography from "../../../../components/SoftTypography";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import { LuFileCode2 } from "react-icons/lu";
import { LuFileSearch } from "react-icons/lu";
import AppBar from "@mui/material/AppBar";
import {removeDiacritics} from "../../../../axios-client";
import {IconButton, Tooltip, useMediaQuery, useTheme} from "@mui/material";
import RemoveDiacritics from "../../../../reusableComponents/Icons/RemoveDiacritics"
import RegenerateServicesPopup from "../editorToolbarComponents/RegenerateServicesPopup";
import { Undo2, Redo2, Languages, FileText } from "lucide-react";
import { Box, Button, Divider, ButtonGroup } from "@mui/material"
import PageSelectorDialog from "../editorToolbarComponents/PageSelectorDialog";

import { useTranslation } from "react-i18next";
import FontSize from "../editorToolbarComponents/editorToolbarElements/FontSize";

const DigitizationMarkdownComponent = ({
    pageNumber, updateConfigWidth, page, sourceLanguage, targetLanguage, addOrUpdatePages, updatedPages,
    handleSave, translationSelected, diacriticsSelected,  digitizationId, numPages, fileName, fetchData, articleId
                                       }) => {

    const { t, i18n } = useTranslation(['editor']);
    const dir = i18n.dir();

    const [tabValue, setTabValue] = useState(0);
    const [displayExtractedText, setDisplayExtractedText] = useState(true);
    const [markdownContent, setMarkdownContent] = useState('');
    const [translatedContent, setTranslatedContent] = useState('');
    const [loading, setLoading] = useState(false);
    const [audioUrl, setAudioUrl] = useState('');
    const [fontSize, setFontSize] = useState(16);
    const noContentTags = ["No OCR is available.", "No Translation is available.", "NO-TEXT due to harmful content."];
    const [pageHistories, setPageHistories] = useState({});

    const currentHistory = pageHistories[pageNumber] || { history: [], index: -1 };
    const canUndo = currentHistory.index > 0;
    const canRedo = currentHistory.index < currentHistory.history.length - 1;
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const isTablet = useMediaQuery(theme.breakpoints.down("md"));

    const [openRemoveDiacriticsPopup, setOpenRemoveDiacriticsPopup] = useState(false);
    const [option, setOption] = useState("current");
    const [pageRange, setPageRange] = useState("");
    const [isValidPageRange, setIsValidPageRange] = useState(true);

    const [translatedHistories, setTranslatedHistories] = useState({});
    const currentTranslatedHistory = translatedHistories[pageNumber] || { history: [], index: -1 };
    const canUndoTranslated = currentTranslatedHistory.index > 0;
    const canRedoTranslated = currentTranslatedHistory.index < currentTranslatedHistory.history.length - 1;
    const isRtl = dir === "rtl" ;


    const handleConfirmDiacriticsRemoval = () => {
        setOpenRemoveDiacriticsPopup(false);
        const params = {
            option,
            pageRange,
            currentPage: pageNumber,
            articleId: articleId
        }
        removeMarkdownDiacritics(params);
    };

    const handleSetPageRange = (range, valid) => {
        setPageRange(range);
        setIsValidPageRange(valid);
    };

    const handleOpenRemoveDiacriticsDialog = () => {
        setOpenRemoveDiacriticsPopup(true);
    };

    const handleCloseRemoveDiacriticsDialog = () => {
        setOpenRemoveDiacriticsPopup(false);
    };

    const pushSnapshot = useCallback((newMarkdownContent) => {
        const snapshot = {
            markdown: newMarkdownContent
        };
        setPageHistories(prev => {
            const current = prev[pageNumber] || { history: [], index: -1 };
            const history = current.history;
            // if the index is not the last, we add a new indexed history
            if (current.index != history.length - 1) {
                let duplicateIndex = current.history[current.index]
                history.push(duplicateIndex);
            }
            history.push(snapshot);
            return {
                ...prev,
                [pageNumber]: { history, index: history.length - 1 },
            };
        });
    }, [markdownContent]);

    const pushInitialSnapshot = useCallback((initialMarkdown) => {
        const snapshot = { markdown: initialMarkdown };
        setPageHistories(prev => {
            if (!prev[pageNumber]) {
                return {
                    ...prev,
                    [pageNumber]: { history: [snapshot], index: 0 },
                };
            }
            return prev;
        });
    }, [pageNumber]);

    const handleUndo = useCallback(() => {
        setPageHistories(prev => {
            const current = prev[pageNumber];
            if (!current || current.index <= 0) return prev;
            const newIndex = current.index - 1;
            setMarkdownContent(current.history[newIndex].markdown);
            addOrUpdatePages(pageNumber, current.history[newIndex].markdown, 'markdown');
            return {
                ...prev,
                [pageNumber]: { ...current, index: newIndex },
            };
        });
    }, [pageNumber]);

    const handleRedo = useCallback(() => {
        setPageHistories(prev => {
            const current = prev[pageNumber];
            if (!current || current.index >= current.history.length - 1) return prev;
            const newIndex = current.index + 1;
            setMarkdownContent(current.history[newIndex].markdown);
            addOrUpdatePages(pageNumber, current.history[newIndex].markdown, 'markdown');
            return {
                ...prev,
                [pageNumber]: { ...current, index: newIndex },
            };
        });
    }, [pageNumber]);

    useEffect(() => {
        if (page && page.markdown) {
            checkPageType(page);
            pushInitialSnapshot(page.markdown);
        }
    }, [page]);

    useEffect(() => {
        if (page && page.translated_text) {
            setTranslatedHistories(prev => {
                const current = prev[pageNumber];
                if (current) {

                    setTranslatedContent(current.history[current.index]);
                    return prev;
                }

                const initialTranslated = page.translated_text ?? "";
                setTranslatedContent(initialTranslated);
                return {
                    ...prev,
                    [pageNumber]: {
                        history: [initialTranslated],
                        index: 0
                    }
                };
            });
        }
    }, [page]);

    const handleUndoTranslated = () => {
        setTranslatedHistories(prev => {
            const current = prev[pageNumber];
            if (!current || current.index <= 0) return prev;
            const newIndex = current.index - 1;
            setTranslatedContent(current.history[newIndex]);
            addOrUpdatePages(pageNumber, current.history[newIndex], 'translated_text');
            return {
                ...prev,
                [pageNumber]: { ...current, index: newIndex },
            };
        });
    };

    const handleRedoTranslated = () => {
        setTranslatedHistories(prev => {
            const current = prev[pageNumber];
            if (!current || current.index >= current.history.length - 1) return prev;
            const newIndex = current.index + 1;
            setTranslatedContent(current.history[newIndex]);
            addOrUpdatePages(pageNumber, current.history[newIndex], 'translated_text');
            return {
                ...prev,
                [pageNumber]: { ...current, index: newIndex },
            };
        });
    };

    useEffect(() => {
        const onKeyDown = (e) => {
            if ((e.ctrlKey || e.metaKey) && e.key === 'z') {
                e.preventDefault();
                displayExtractedText ? handleUndo() : handleUndoTranslated();
            } else if ((e.ctrlKey || e.metaKey) && e.key === 'y') {
                e.preventDefault();
                displayExtractedText ? handleRedo() : handleRedoTranslated();
            }
        };
        window.addEventListener('keydown', onKeyDown);
        return () => window.removeEventListener('keydown', onKeyDown);
    }, [displayExtractedText, handleUndo, handleRedo, handleUndoTranslated, handleRedoTranslated]);

    const checkPageType = (currentPage) => {
        switch (currentPage.type) {
            case "NO_TEXT":
                setMarkdownContent("No TEXT.");
                setTranslatedContent("No TEXT.");
                break;
            case "TEXT":
                setMarkdownContent(currentPage.markdown ?? "No OCR is available.")
                setTranslatedContent(currentPage.translated_text ?? "No Translation is available.");
                break;
            default:
                setMarkdownContent(currentPage.markdown ?? "No OCR is available.")
                setTranslatedContent(currentPage.translated_text ?? "No Translation is available.");
        }
    }


    const handleSwitchChange = (value) => {
        setDisplayExtractedText(value);
    };

    useEffect(() => {
        if (page) {
            checkPageType(page);
            setAudioUrl(page.audio_path);
        }
    }, [page]);

    const updateMarkdown = (e) => {
        if (page.type === 'TEXT' || page.type === null) {
            let newMarkdown = e.target.value
            pushSnapshot(newMarkdown);
            setMarkdownContent(newMarkdown);
            addOrUpdatePages(pageNumber, newMarkdown, 'markdown');
        }
    }

    const removeMarkdownDiacritics = (params) => {
        setLoading(true);
        removeDiacritics(params)
            .then((response) => {
                const { pages } = response.data;
                if (Array.isArray(pages)) {
                    pages.forEach(({ page, text_without_diacritics }) => {
                        addOrUpdatePages(page, text_without_diacritics, 'markdown');
                        if (page === pageNumber) {
                            setMarkdownContent(text_without_diacritics);
                        }
                    });
                }
            })
            .catch((e) => {
                console.error('Error removing diacritics:', e)
            })
            .finally(() => {
                setLoading(false);
            });
    } 

    const updateTranslatedMarkdown = (e) => {
        if (page.type === 'TEXT' || page.type === null) {
            setTranslatedContent(e.target.value);
            addOrUpdatePages(pageNumber, e.target.value, 'translated_text');
            setTranslatedHistories(prev => {
                const current = prev[pageNumber] || { history: [], index: -1 };
                const newHistory = [...current.history.slice(0, current.index + 1), e.target.value];
                return {
                    ...prev,
                    [pageNumber]: {
                        history: newHistory,
                        index: newHistory.length - 1
                    }
                };
            });
        }
    }

    const handleContentSectionMouseDown = useCallback((e) => {
        e.preventDefault();
        const initialWidth = e.target.parentElement.offsetWidth;
        const initialDivWidth = e.target.offsetParent.offsetWidth;
        const initialX = e.clientX;

        const handleMouseContentSectionMove = (e) => {
            let newWidth = initialWidth - (e.clientX - initialX);

            if (newWidth < initialDivWidth * 0.2) {
                newWidth = (initialDivWidth * 0.2);
            } else if (newWidth > initialDivWidth * 0.75) {
                newWidth = (initialDivWidth * 0.75);
            }

            const contentSection = document.getElementById("digitizationEditorMarkdownSection");
            if (contentSection && contentSection.offsetWidth !== newWidth) {
                contentSection.style.width = newWidth + 'px';
                updateConfigWidth(newWidth);
            }
            const event = new CustomEvent('configResized');
            window.dispatchEvent(event);
        };

        const handleMouseContentSectionUp = () => {
            document.removeEventListener('mousemove', handleMouseContentSectionMove);
            document.removeEventListener('mouseup', handleMouseContentSectionUp);
        };

        document.addEventListener('mousemove', handleMouseContentSectionMove);
        document.addEventListener('mouseup', handleMouseContentSectionUp);
    }, [updateConfigWidth]);


    const diacritizeText = () => {
        setLoading(true);
        diacritizeDraft(markdownContent)
            .then((response) => {
                let newMarkdown = response.data.markdown;
                if (newMarkdown) {
                    setMarkdownContent(newMarkdown)
                    addOrUpdatePages(pageNumber, newMarkdown, 'markdown');
                }
            })
            .catch(e => {
                console.log('error', e)
            })
            .finally(() => {
                setLoading(false);
            });
    }

    const handleSaveWithLoading = () => {
        setLoading(true);
        handleSave()
            .then(() => {
                // success handled in handleSave
            })
            .catch((err) => {
            })
            .finally(() => {
                setLoading(false);
            });
    };
    const handleSetTabEditorPreviewValue = (event, newValue) => setTabValue(newValue);

    return (
        <div className="digitizationEditorMarkdownSection" id="digitizationEditorMarkdownSection"
             style={{display: 'flex', flexDirection: 'column', height: '100%', maxHeight: '100vh'}}
        >
            <div className="resize-handle" onMouseDown={handleContentSectionMouseDown}/>
            <Box sx={{
                borderBottom: "1px solid #e0d8d8b0",
                px: { xs: 1, sm: 2 },
                py: { xs: 0.5, sm: 1 },
                height: { xs: "auto", sm: "3.5rem" },
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                flexWrap: { xs: "wrap", md: "nowrap" },
                gap: { xs: 1, sm: 2 },
                minWidth: "max-content",
            }}
                 dir={dir}
            >
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    {displayExtractedText && (
                    <>
                        <FontSize
                            fontSize={fontSize}
                            setFontSize={setFontSize}
                        />

                        <Tooltip title="Undo (Ctrl+Z)">
                        <span>
                            <IconButton
                                variant="outlined"
                                size={isMobile ? "small" : "medium"}
                                sx={{
                                    width: { xs: 28, sm: 32 },
                                    height: { xs: 28, sm: 32 },
                                    fontSize: { xs: "0.65rem", sm: "0.75rem" },
                                    color: "#616161",
                                    border: "1px solid #d8d6d6",
                                    borderRadius:"5px",
                                    p: 1,
                                    "&:hover": {
                                        borderColor: "#757575",
                                        background: "#F5F5F5",
                                    },
                                }}
                                onClick={handleUndo} disabled={!canUndo}>
                            <Undo2 size={isMobile ? 14 : 16} />
                            </IconButton>
                        </span>
                        </Tooltip>

                        <Tooltip title="Redo (Ctrl+Y)">
                        <span>
                            <IconButton
                                variant="outlined"
                                size={isMobile ? "small" : "medium"}
                                sx={{
                                    width: { xs: 28, sm: 32 },
                                    height: { xs: 28, sm: 32 },
                                    fontSize: { xs: "0.65rem", sm: "0.75rem" },
                                    color: "#616161",
                                    border: "1px solid #d8d6d6",
                                    borderRadius:"5px",
                                    p:1,
                                    "&:hover": {
                                        borderColor: "#757575",
                                        background: "#F5F5F5",
                                    },
                                }}
                                onClick={handleRedo} disabled={!canRedo}>
                                <Redo2 size={isMobile ? 14 : 16} />
                            </IconButton>
                        </span>
                        </Tooltip>
                    </>
                    )}

                    {!displayExtractedText && (
                        <>
                            <Tooltip title="Undo Translation (Ctrl+Z)">
                                <span>
                                    <IconButton
                                        variant="outlined"
                                        size={isMobile ? "small" : "medium"}
                                        sx={{
                                            width: { xs: 28, sm: 32 },
                                            height: { xs: 28, sm: 32 },
                                            fontSize: { xs: "0.65rem", sm: "0.75rem" },
                                            color: "#616161",
                                            border: "1px solid #d8d6d6",
                                            borderRadius:"5px",
                                            p:1,
                                            "&:hover": {
                                                borderColor: "#757575",
                                                background: "#F5F5F5",
                                            },
                                        }}
                                        onClick={handleUndoTranslated} disabled={!canUndoTranslated}>
                                         <Undo2 size={isMobile ? 14 : 16} />
                                    </IconButton>
                                </span>
                            </Tooltip>

                            <Tooltip title="Redo Translation (Ctrl+Y)">
                                <span>
                                    <IconButton
                                        variant="outlined"
                                        size={isMobile ? "small" : "medium"}
                                        sx={{
                                            width: { xs: 28, sm: 32 },
                                            height: { xs: 28, sm: 32 },
                                            fontSize: { xs: "0.65rem", sm: "0.75rem" },
                                            color: "#616161",
                                            border: "1px solid #d8d6d6",
                                            borderRadius:"5px",
                                            p:1,
                                            "&:hover": {
                                                borderColor: "#757575",
                                                background: "#F5F5F5",
                                            },
                                        }}
                                        onClick={handleRedoTranslated} disabled={!canRedoTranslated}>
                                        <Redo2 size={isMobile ? 14 : 16} />
                                    </IconButton>
                                </span>
                            </Tooltip>
                        </>
                    )}


                </Box>

                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                    <ButtonGroup
                        variant="outlined"
                        disableElevation
                        sx={{
                            bgcolor: "#ffffff !important",
                            "& .MuiButton-root": {
                                height: 32,
                                fontSize: "0.75rem",
                                color: "#616161", // grey.700
                                borderColor: "#bdbdbd !important", // grey.400
                                "&:hover": {
                                    borderColor: "#757575 !important", // grey.600
                                    bgcolor: "#f5f5f5 !important", // grey.100
                                },
                                "&.Mui-focusVisible, &:focus": {
                                    outline: "none !important",
                                    boxShadow: "none !important",
                                },
                            },
                            "& .MuiButton-contained": {
                                bgcolor: "#424242 !important", // grey.800
                                color: "#ffffff",
                                "&:hover": {
                                    bgcolor: "#212121 !important",
                                    borderColor: "#bdbdbd !important",// grey.900
                                },
                            },
                            "&.Mui-focusVisible, &:focus": {
                                bgcolor: "#212121 !important",
                                borderColor: "#bdbdbd !important",
                                outline: "none !important",
                                boxShadow: "none !important",
                            },
                            "& .MuiButtonGroup-firstButton": {
                                borderTopLeftRadius: isRtl ? 0 : 4,
                                borderBottomLeftRadius: isRtl ? 0 : 4,
                                borderTopRightRadius: isRtl ? 4 : 0,
                                borderBottomRightRadius: isRtl ? 4 : 0,
                            },
                            "& .MuiButtonGroup-lastButton": {
                                borderTopRightRadius: isRtl ? 0 : 4,
                                borderBottomRightRadius: isRtl ? 0 : 4,
                                borderTopLeftRadius: isRtl ? 4 : 0,
                                borderBottomLeftRadius: isRtl ? 4 : 0,
                            },
                        }}
                    >
                        <Button
                            variant={displayExtractedText ? "contained" : "outlined"}
                            onClick={() => handleSwitchChange(true)}
                            startIcon={<FileText size={isMobile ? 10 : 12} />}
                            sx={{
                                fontSize: { xs: "0.65rem", sm: "0.75rem" },
                                px: { xs: 1, sm: 2 },
                                minWidth: { xs: 32, sm: "auto" },
                                "& .MuiButton-startIcon": {
                                    marginLeft: dir === "rtl" ? "0.3rem" : "-4px",
                                    marginRight: dir === "rtl" ? "0px" : "8px"
                                },
                            }}
                        >
                            {isMobile ? "E" : t("extracted_text")}
                        </Button>

                        {translationSelected && (
                            <Button
                                variant={!displayExtractedText ? "contained" : "outlined"}
                                onClick={() => handleSwitchChange(false)}
                                startIcon={<Languages size={isMobile ? 10 : 12} />}
                                sx={{
                                    fontSize: { xs: "0.65rem", sm: "0.75rem" },
                                    px: { xs: 1, sm: 2 },
                                    minWidth: { xs: 32, sm: "auto" },
                                    "& .MuiButton-startIcon": {
                                        marginLeft: dir === "rtl" ? "0.3rem" : "-4px",
                                        marginRight: dir === "rtl" ? "0px" : "8px"
                                    },
                                }}
                            >
                                {isMobile ? "T" : t("translated_text")}
                            </Button>
                        )}
                    </ButtonGroup>
                </Box>

                <React.Fragment>
                    <Box sx={{display: "flex", alignItems: "center", gap: 1}}>

                        <RegenerateServicesPopup digitizationId={digitizationId} currentPageNum={pageNumber}
                                                 numPages={numPages} fetchData={fetchData}/>

                        {
                            sourceLanguage == 'Arabic' && diacriticsSelected && <Tooltip title={t('remove_diacritics')}>
                            <span>
                                <IconButton
                                    variant="outlined"
                                    size={isMobile ? "small" : "medium"}
                                    sx={{
                                        width: {xs: 28, sm: 32},
                                        height: {xs: 28, sm: 32},
                                        fontSize: {xs: "0.65rem", sm: "1.3rem"},
                                        color: "#616161",
                                        border: "1px solid #d8d6d6",
                                        borderRadius: "5px",
                                        padding: "0px !important",
                                        "&:hover": {
                                            borderColor: "#757575",
                                            background: "#F5F5F5",
                                        },
                                    }}
                                    onClick={handleOpenRemoveDiacriticsDialog}
                                >
                                    <RemoveDiacritics/>
                                </IconButton>
                            </span>
                            </Tooltip>
                        }

                        <SaveButton updatedPages={updatedPages} handleSave={handleSaveWithLoading} disabled={loading}
                                    t={t} dir={dir}/>
                       

                    </Box>
                </React.Fragment>

            </Box>

            <div style={{ padding: "0px 15px 0px 15px", flexGrow: 1, overflow: 'auto' }}>
                {loading && (
                    <div style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(255,255,255,0.7)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 10
                    }}>
                        <CircularProgress/>
                    </div>
                )}

                <div>
                    <SoftBox>
                        <SoftTypography variant="h6" style={{display: "flex", justifyContent: 'center'}}>
                            <AppBar position="static">
                                <Tabs
                                    orientation={"horizontal"}
                                    value={tabValue}
                                    onChange={handleSetTabEditorPreviewValue}
                                    sx={{ background: "transparent" }}
                                >
                                    <Tab label={t('editor')} icon={<LuFileCode2 />} />
                                    <Tab label={t('preview')} icon={<LuFileSearch />} />
                                </Tabs>
                            </AppBar>
                        </SoftTypography>
                        <Divider style={{color: "blue", margin: "0.5rem 0"}}/>
                    </SoftBox>

                    <SoftBox
                        role="tabpanel"
                        hidden={tabValue !== 0}
                    >
                        <textarea
                            disabled={loading}
                            onChange={displayExtractedText ? updateMarkdown : updateTranslatedMarkdown}
                            value={displayExtractedText ? markdownContent : translatedContent}
                            className="digitization-note"
                            style={{
                                borderColor: '#e6e6e7',
                                borderRadius: '4px',
                                width: '100%',
                                minHeight: '70vh',
                                padding: "15px",
                                direction: displayExtractedText ? getScriptDirection(sourceLanguage) : getScriptDirection(targetLanguage),
                                height: '100%',
                                boxSizing: 'border-box',
                                overflowX: 'auto',
                                whiteSpace: 'pre-wrap',
                                fontWeight: "500",
                                fontFamily: "system-ui",
                                fontSize: fontSize + "px"
                            }}
                            placeholder="Text content will appear here."
                        />
                    </SoftBox>
                    <SoftBox
                        role="tabpanel"
                        hidden={tabValue !== 1}
                    >
                        <SoftBox style={{
                            direction: displayExtractedText ? getScriptDirection(sourceLanguage) : getScriptDirection(targetLanguage),
                            backgroundColor: "white",
                            border: 'solid 0.1px lightgray',
                            borderRadius: '5px',
                            padding: "5px",
                            whiteSpace: 'pre-wrap'
                        }}>

                            {displayExtractedText ?
                                <ReactMarkdown>
                                    {markdownContent}
                                </ReactMarkdown> : <ReactMarkdown>
                                    {translatedContent}
                                </ReactMarkdown>
                            }
                        </SoftBox>
                    </SoftBox>
                </div>


            </div>
            {displayExtractedText && audioUrl && !loading && (
                <AudioPlayer audioUrl={audioUrl}/>
            )}


            <PageSelectorDialog 
                open={openRemoveDiacriticsPopup}
                handleCloseDialog={handleCloseRemoveDiacriticsDialog}
                dialogTitle={t("remove_diacritics")}
                handleConfirm={handleConfirmDiacriticsRemoval}
                loading={loading}
                t={t}
                option={option}
                setOption={setOption}
                numberOfPage={numPages}
                pageRange={pageRange}
                setPageRange={handleSetPageRange}
                isValidPageRange={isValidPageRange}
                direction={dir}
            />
        </div>
    )
}

DigitizationMarkdownComponent.propTypes = {
    containerWidth: PropTypes.string,
    pageNumber: PropTypes.number,
    digitizationId: PropTypes.number,
    configWidth: PropTypes.string,
    updateConfigWidth: PropTypes.func,
    page: PropTypes.object,
    sourceLanguage: PropTypes.string,
    targetLanguage: PropTypes.string,
    addOrUpdatePages: PropTypes.func,
    updatedPages: PropTypes.array,
    handleSave: PropTypes.func,
    translationSelected: PropTypes.bool,
    diacriticsSelected: PropTypes.bool,
    diacritizeWords: PropTypes.func,
    numPages: PropTypes.number,
    fileName: PropTypes.string,
    fetchData: PropTypes.func,
    articleId: PropTypes.number,
};

export default DigitizationMarkdownComponent;
